export default "__VITE_ASSET__BanTZ9EB__"